import React, { Component } from 'react';
import { connect } from 'react-redux';
import Orders from './orders';
import {takeLast,take} from 'ramda';
import {lowestDenom} from '../../../../config';
import {Decimal} from 'decimal.js'
import InfiniteScroll from '../../../helper/infinite';

class Sell extends Component {
  constructor(){
    super()
    this.state = {hasMore:false,nextIndex:1,orders:[]}
  }
  componentDidUpdate(prevProps){
    // console.log(hash(this.props.orders),hash(prevProps.orders))
    if(prevProps.marketText != this.props.marketText){
      this.setState({orders:takeLast(20,this.props.orders),hasMore:true,nextIndex:1})
    }
    else if(prevProps.orders.length === 0 && this.props.orders.length > 0){
      this.setState({orders:takeLast(20,this.props.orders),hasMore:true,nextIndex:1})
    }
    else if(this.props.orders.length != prevProps.orders.length){
      this.setState({hasMore:true,orders:takeLast(this.state.nextIndex*20,this.props.orders)})
    }
    else if(this.props.ordersHash != prevProps.ordersHash){
      this.setState({hasMore:true,orders:takeLast(20,this.props.orders),nextIndex:1})
    }
  }
  componentDidMount(){
    this.setState({orders:takeLast(20,this.props.orders),hasMore:true})
  }
  fetchMoreData(){
    console.log('called this')
    if(this.state.hasMore){
      let { nextIndex, orders} = this.state;
      nextIndex++;
      this.setState({orders:takeLast(20*nextIndex,this.props.orders),nextIndex})
      if(20*nextIndex >= this.props.orders.length){
        this.setState({hasMore:false,nextIndex})
      }
      console.log({nextIndex,hasMore:this.state.hasMore})
    }
    return;
  }
  render() {
    let display = this.props.market.sellSide == false ? 'none' : ''

    return (
      <div className="col s12 mainbook" id='sellSideDiv' style={{display}}>
        <InfiniteScroll position={300} onReachTop={this.fetchMoreData.bind(this)} hasMore={this.state.hasMore}>
          <Orders orderType={"sell"} orders={this.state.orders}/>
        </InfiniteScroll>
      </div>
    );
  }
}

function mapStateToProps(state,props) {
  let orders =  state.orderbook.sub_offers.slice(0);

  return {
    marketText: `${state.ui_marketplace.market.denomination}${state.ui_marketplace.market.asset}`,
    market: state.ui_marketplace.market,
    ordersHash: state.orderbook.sub_offers_hash,
    orders
  };
}

export default connect(mapStateToProps,{})(Sell);
